export const hero = {
    title: "Full-Stack Developer",

    firstName:"Jamie",
    lastName:"Spencer",

    tagline:"I build tools that help people",

    description:"Most of my experience comes from internships and personal projects where I’ve had to jump into unfamiliar codebases, figure things out quickly, and keep learning as I go. I enjoy working across the stack and understanding how all the pieces fit together."
}